// src/api/axiosInstance.ts
import axios from 'axios';

const API_BASE_URL =
    process.env.NODE_ENV === 'development'
        ? 'http://localhost:8080'
        : 'https://api.sonabelanska.sk';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// This interceptor runs BEFORE EVERY request
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('jwtToken');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        console.log('Authorization header attached:', `Bearer ${token.substring(0, 20)}...`);
    } else {
        console.log('No token in localStorage – sending request without Authorization');
    }

    return config;
});

// Global 401 handler (auto logout)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            console.log('401 detected → logging out');
            localStorage.removeItem('jwtToken');
            window.dispatchEvent(new Event('auth-change'));
            // Optional: redirect
            // if (window.location.pathname !== '/login') {
            //   window.location.href = '/login';
            // }
        }
        return Promise.reject(error);
    }
);

export default api;